import { useSelector } from 'react-redux'
import HepatitisForm from './HepatitisForm'
import { RootState } from '../../redux-store'
import styled from '@emotion/styled'
import Breadcrumb from '../../components/common/Breadcrumb'
import HepatitisInfo from './HepatitisInfo'
import { useRouter } from '../../utils/helper'
import { useGetHepatitisById } from '../../services/hepatitis/hepatitis-query'
import { home } from '../../constant/path'
import { pullAt } from 'lodash'
import { useScreen } from '../../utils/responsive-helper'
import Headbar from '../../components/common/HeadBar'
import { hepatitisDetail } from '../../constant/path'
import { useTranslation } from 'react-i18next'
import { mobile } from '../../utils/responsive-helper'
import { HepatitisInfoWithConcentDate, HepatitisInfoWithoutConcentDate } from '../../redux-store/hepatitis-reducer'
import color from '../../constant/colors'

const BackgroundHeader = styled.div`
  background-color: ${color.CHOICES_PRIMARY};
  width: calc(100% - 32px);
  height: 266px;
  margin-top: 0px !important;
  position: absolute;

  ${mobile} {
    width: 100%;
  }
`
const Layout = styled.div`
  width: 768px;
  margin: 0 auto;
  z-index: 1;
  > * {
    margin-top: 24px;
  }

  ${mobile} {
    width: 100%;
  }
`

const HepatitisSummary = () => {
  const { query } = useRouter<{ hepatitisId: number }>()
  const { t } = useTranslation()
  const { isMobile } = useScreen()
  const { data: hepatitisItem } = useGetHepatitisById({ claimId: query.hepatitisId })

  const hepatitisFormValue = useSelector((state: RootState) => state.hepatitis.claimInfo) as HepatitisInfoWithConcentDate & HepatitisInfoWithoutConcentDate

  return (
    <>
      <BackgroundHeader />
      <Layout>
        <Headbar title={hepatitisItem?.name || ''} backWard={hepatitisDetail({ routeParam: { hepatitisId: query.hepatitisId } })} />
        {/* <HepatitisInfo hepatitisItem={hepatitisItem} editable={false} /> */}
        <HepatitisForm
          hepatitisItem={hepatitisItem}
          hepatitisId={query.hepatitisId}
          hepatitisFormValue={hepatitisFormValue}
          editable={false}
          isPreview={true}
        />
      </Layout>
    </>
  )
}

export default HepatitisSummary
